import React from "react";
import {
  NumberInput,
  required,
  SimpleForm,
  TextInput,
  SelectInput,
  useTranslate,
} from "react-admin";
import { Card, CardContent, CardHeader } from "@mui/material";

const headerStyle = {
  backgroundColor: "#2196f3", // Default blue color of React Admin
  color: "white",
  padding: "8px 16px",
  fontWeight: "bold",
};

const RuleDeemedSupplierForm: React.FC = () => {
  const translate = useTranslate();

  return (
    <SimpleForm>
      {/* General Information Section */}
      <Card style={{ marginBottom: "1.5rem", width: "100%" }}>
        <CardHeader
          title={translate("rulesDeemedSupplier.fields.generalInfo")}
          style={headerStyle}
        />
        <CardContent>
          <TextInput
            source="name"
            label={translate("rulesDeemedSupplier.fields.name.label")}
            validate={required()}
            fullWidth
            helperText={translate("rulesDeemedSupplier.fields.name.helper")}
          />

          <NumberInput
            source="threshold"
            label={translate("rulesDeemedSupplier.fields.threshold.label")}
            validate={required()}
            min={0}
            fullWidth
            helperText={translate(
              "rulesDeemedSupplier.fields.threshold.helper",
            )}
          />

          <TextInput
            source="taxIdentifier24s"
            label={translate(
              "rulesDeemedSupplier.fields.taxIdentifier24s.label",
            )}
            validate={required()}
            fullWidth
            helperText={translate(
              "rulesDeemedSupplier.fields.taxIdentifier24s.helper",
            )}
          />

          <TextInput
            source="taxIdentifierName"
            label={translate(
              "rulesDeemedSupplier.fields.taxIdentifierName.label",
            )}
            validate={required()}
            fullWidth
            helperText={translate(
              "rulesDeemedSupplier.fields.taxIdentifierName.helper",
            )}
          />
        </CardContent>
      </Card>

      {/* Countries Section */}
      <Card style={{ marginBottom: "1.5rem", width: "100%" }}>
        <CardHeader
          title={translate("rulesDeemedSupplier.fields.countries")}
          style={headerStyle}
        />
        <CardContent>
          <TextInput
            source="countriesFrom"
            label={translate("rulesDeemedSupplier.fields.countriesFrom.label")}
            validate={required()}
            fullWidth
            helperText={translate(
              "rulesDeemedSupplier.fields.countriesFrom.helper",
            )}
          />

          <TextInput
            source="countriesTo"
            label={translate("rulesDeemedSupplier.fields.countriesTo.label")}
            validate={required()}
            fullWidth
            helperText={translate(
              "rulesDeemedSupplier.fields.countriesTo.helper",
            )}
          />

          <TextInput
            source="exceptCountriesFrom"
            label={translate(
              "rulesDeemedSupplier.fields.exceptCountriesFrom.label",
            )}
            fullWidth
            helperText={translate(
              "rulesDeemedSupplier.fields.exceptCountriesFrom.helper",
            )}
          />
        </CardContent>
      </Card>

      {/* Financial Information Section */}
      <Card style={{ marginBottom: "1.5rem", width: "100%" }}>
        <CardHeader
          title={translate("rulesDeemedSupplier.fields.financialInfo")}
          style={headerStyle}
        />
        <CardContent>
          <SelectInput
            source="currency"
            label={translate("rulesDeemedSupplier.fields.currency.label")}
            validate={required()}
            choices={[
              { id: "USD", name: "USD" },
              { id: "EUR", name: "EUR" },
              { id: "GBP", name: "GBP" },
            ]}
            fullWidth
            helperText={translate("rulesDeemedSupplier.fields.currency.helper")}
          />

          <TextInput
            source="sapAccount1"
            label={translate("rulesDeemedSupplier.fields.sapAccount1.label")}
            validate={required()}
            fullWidth
            helperText={translate(
              "rulesDeemedSupplier.fields.sapAccount1.helper",
            )}
          />

          <TextInput
            source="sapAccount2"
            label={translate("rulesDeemedSupplier.fields.sapAccount2.label")}
            fullWidth
            helperText={translate(
              "rulesDeemedSupplier.fields.sapAccount2.helper",
            )}
          />
        </CardContent>
      </Card>
    </SimpleForm>
  );
};

export default RuleDeemedSupplierForm;
